// extracted by mini-css-extract-plugin
export default {"search-box":"search-box_search-box__A2fL7","savior-search":"search-box_savior-search__3WMmS"};